import Vue from "vue";
import Vuex from "vuex";

import createMultiTabState from "vuex-multi-tab-state";

import basket from "./basket";
import user from "./user";
import checkout from "./checkout";
import readiness from "./readiness";
import winelist from "./winelist";
import wishlist from "./wishlist";

Vue.use(Vuex);

var statesPaths = ["basket"];

if (process.env.JBS_SITEMODE === "trade") {
  statesPaths.push("winelist._last_added_to");
}

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== "production",
  state: {},
  mutations: {},
  actions: {},
  modules: {
    basket,
    user,
    checkout,
    readiness,
    winelist,
    wishlist
  },
  plugins: [
    createMultiTabState({
      statesPaths
    })
  ]
});
